class SideMenu {
  constructor(el) {
    this.el = el;
    this.buttonOpen = document.querySelector(".button-side-menu");
    this.buttonClose = this.el.querySelector(".button-close");

    this.bindListeners();
  }

  bindListeners() {
    this.buttonOpen?.addEventListener("click", () => this.open());
    this.buttonClose?.addEventListener("click", () => this.close());

    this.el.querySelectorAll(".menu-item-has-children > a").forEach((link) => {
      link.addEventListener("click", (e) => this.toggleSubmenu(e, link));
    });
  }

  open() {
    this.el.classList.add("open");
    document.body.classList.add("modal-opened");
  }

  close() {
    this.el.classList.remove("open");
    document.body.classList.remove("modal-opened");
  }

  toggleSubmenu(e, link) {
    e.preventDefault();
    const submenu = link.nextElementSibling;
    if (submenu?.classList.contains("sub-menu")) {
      submenu.classList.toggle("submenu-show");
    }
  }
}

const sideMenuEl = document.getElementById("side-menu");
if (sideMenuEl) {
  new SideMenu(sideMenuEl);
}
